import { HashLink } from 'react-router-hash-link';
import GenespLI from './GenespLI';
import GenesProteinClass from './GenesProteinClass';
import GenesUniProt from './GenesUniProt';

function AboutAttributesGenes() {
  return (
    <div id="section41">
      <h3>Genes</h3>
      <p>
        <strong>Genes in DISGENET are annotated with: </strong>
      </p>
      <ul>
        <li className="bullet-item">
          The official gene symbol, from the{' '}
          <a className="tt" target="_blank" rel="noreferrer" href="http://www.ncbi.nlm.nih.gov/gene/">
            NCBI
          </a>
        </li>
        <li className="bullet-item">
          The{' '}
          <a className="tt" target="_blank" rel="noreferrer" href="http://www.ncbi.nlm.nih.gov/gene/">
            NCBI
          </a>{' '}
          Official Full Name
        </li>
        <li className="bullet-item">
          The{' '}
          <a className="tt" target="_blank" rel="noreferrer" href="https://www.ensembl.org/">
            {' '}
            Ensembl
          </a>{' '}
          Gene identifier
        </li>
        <GenesUniProt />
        <li className="bullet-item">
          The{' '}
          <HashLink to="#specificity" data-target="#metrics" data-toggle="tab" className="js-fix-scroll">
            Disease Specificity Index{' '}
          </HashLink>
          (DSI)
        </li>
        <li className="bullet-item">
          The{' '}
          <HashLink to="#pleiotropy" data-target="#metrics" data-toggle="tab" className="js-fix-scroll">
            Disease Pleiotropy Index{' '}
          </HashLink>
          (DPI)
        </li>
        <GenespLI />
        <GenesProteinClass />
        <li className="bullet-item">
          The pathways are obtained from top-level pathways from{' '}
          <a className="tt" target="_blank" rel="noreferrer" href="https://reactome.org/">
            Reactome
          </a>
          .
        </li>
      </ul>
    </div>
  );
}
export default AboutAttributesGenes;
